export const HOLIDAY_DATE_FIELD_ID = 'date';
export const HOLIDAY_NAME_FIELD_ID = 'title';
export const HOLIDAY_COMPANY_FIELD_ID = 'tenant';
// export const HOLIDAY_DEFAULT_IMAGE = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTuOVks6I2awgTW9r30Xbfp_jtsLR-yxuGIQ&usqp=CAU"; 

export const HOLIDAY_PATH="/home/holidays";